import { render } from "./ReporteVentaGeneralView.vue?vue&type=template&id=6947dfd5"
import script from "./ReporteVentaGeneralView.vue?vue&type=script&lang=js"
export * from "./ReporteVentaGeneralView.vue?vue&type=script&lang=js"

import "./ReporteVentaGeneralView.vue?vue&type=style&index=0&id=6947dfd5&scope=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__